<ng-template #nullDefault> <em>N/A</em> </ng-template>

<div class="card">
	<div class="card-body text-primary">
		<h6 class="card-title">
			{{ assessment.customerName }}
		</h6>
		<div class="schedule-card-container">
			<div class="schedule-card">
				<ng-container *ngIf="assessment.assignment.dateTime">
					<div>
						<i class="bi bi-calendar"></i>
						{{ assessmentDateTime }}
					</div>
				</ng-container>

				<ng-container *ngIf="assessment.customerProperty?.fullAddress">
					<app-link-location [property]="assessment.customerProperty" [maxCharacters]="50"></app-link-location>
				</ng-container>

				<ng-container *ngIf="assessment.status">
					<app-assessment-status-badge [status]="assessment.status"></app-assessment-status-badge>
				</ng-container>
			</div>
		</div>
	</div>
</div>
